import type { TableDefinition } from '../engine/tables/definition';
import { addStandardHardware } from './standardHardware';

/**
 * New tables start as a simple, playable machine instead of an invalid blank
 * canvas. Creators can immediately preview the table, then reshape/remove the
 * starter hardware or add more mechanisms as they design their own shots.
 */
export function createEmptyTable(): TableDefinition {
  const now = Date.now();
  const base: TableDefinition = {
    schemaVersion: 1,
    id: `custom-${now}`,
    name: 'Untitled Table',
    board: {
      width: 52,
      height: 104,
      inclineDeg: 6.5,
      plungerMaxPower: 110,
      ballsPerGame: 3,
      ballSaverSeconds: 10,
      nudgeCount: 3,
    },
    parts: [],
    theme: {
      presetId: 'blueprint-lab',
      visualPackId: 'blueprint-lab',
      accentColor: '#90e0ef',
      secondaryColor: '#ffffff',
      playfieldColor: '#0b315d',
      playfieldSecondaryColor: '#155292',
      cabinetColor: '#071a2e',
      cabinetEdgeColor: '#163f63',
      metalColor: '#d9edf5',
      rubberColor: '#ffffff',
      flipperColor: '#f9c74f',
      backgroundColor: '#04101e',
      playfieldPattern: 'minimal',
      soundPackId: 'classic-mechanical',
      lightingPreset: 'arcade',
      artSlots: {
        'playfield-center': 'blank',
        apron: 'blank',
        'bumper-cap': 'blank',
        'target-face': 'blank',
        'ramp-decal': 'blank',
        'sling-plastic': 'blank',
      },
    },
    provenance: { isOfficial: false, isPublished: false },
  };
  return addStandardHardware(base);
}